export default "__VITE_ASSET__ZH4VdhkJ__";